import React from "react";
import {Brands} from "@core-ui/utility";
import {useTheme} from "@core-ui/react-stitch";
import {ResponsiveIcon} from "../components/Icon";
import {ColorTheme, IconContainerProps} from "../types";

export const ChevronSquareIcon = ({
  colorTheme,
  ...props
}: IconContainerProps): JSX.Element => {
  const AthletaSVG = (isSmall = false): JSX.Element => {
    const colortheme: ColorTheme = colorTheme || ColorTheme.dark;
    const isLight = colortheme === ColorTheme.light;

    const bgColor = {fill: isLight ? "#fff" : "#111"};
    const chevronShapeColor = {stroke: isLight ? "#111" : "#fff"};

    if (isSmall) {
      return (
        <svg fill="none" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 44.001v-44h44v44H0Z" {...bgColor} fillOpacity=".6" />
          <path
            d="m27.969 18.97-6 6-6-6"
            {...chevronShapeColor}
            strokeWidth="1.5"
          />
        </svg>
      );
    }

    return (
      <svg fill="none" viewBox="0 0 61 61" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 61V0h61v61H0Z" {...bgColor} fillOpacity=".6" />
        <path d="m36.5 27.5-6 6-6-6" {...chevronShapeColor} strokeWidth="1.5" />
      </svg>
    );
  };

  const OldNavySVG = (): JSX.Element => {
    const theme = useTheme();
    const colortheme: ColorTheme = colorTheme || ColorTheme.dark;
    const isLight = colortheme === ColorTheme.light;

    return (
      <svg viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M44 0v44H0V0z"
          fill={isLight ? theme.color.b1 : "#fff"}
          opacity=".75"
        />
        <path
          d="M21.22 27.65a1.1 1.1 0 001.56 0l8.9-8.9a1.1 1.1 0 000-1.55l-1.04-1.04a1.1 1.1 0 00-1.55 0L22 23.21l-7.09-7.05a1.1 1.1 0 00-1.55 0l-1.04 1.04a1.1 1.1 0 000 1.55z"
          fill={isLight ? "#fff" : theme.color.b1}
        />
      </svg>
    );
  };

  const brandIconLargeViewBoxSVGs = {
    [Brands.Athleta]: AthletaSVG(),
    [Brands.BananaRepublic]: null,
    [Brands.BananaRepublicFactoryStore]: null,
    [Brands.Gap]: null,
    [Brands.GapFactoryStore]: null,
    [Brands.OldNavy]: OldNavySVG(),
    crossBrand: null,
  };

  const brandIconSmallViewBoxSVGs = {
    ...brandIconLargeViewBoxSVGs,
    [Brands.Athleta]: AthletaSVG(true),
  };

  return (
    <ResponsiveIcon
      {...props}
      brandIconLargeViewBoxSVGs={brandIconLargeViewBoxSVGs}
      brandIconSmallViewBoxSVGs={brandIconSmallViewBoxSVGs}
      viewboxBreakpoint={props.brandName === Brands.Athleta ? 45 : 32}
    />
  );
};
